import styled from '@emotion/styled';
import { Dialog } from '@gumtree/ui-library';
import {
    boxSizes,
    breakpoints,
    colors,
    fontSizes,
    fontWeights,
    gutterSizes,
    lineHeights,
    mediaQuery,
} from '@gumtree/ui-library/src/base/theme';

export const MessageEncourageDialog = styled(Dialog)`
    box-sizing: border-box;
    padding: ${gutterSizes.xxlarge} ${gutterSizes.xlarge};
    border-radius: ${gutterSizes.base};
    width: 418px;

    ${mediaQuery.until(breakpoints.medium)} {
        position: absolute;
        bottom: 0;
        margin: 0;
        padding: ${gutterSizes.xlarge} ${gutterSizes.large} ${gutterSizes.large};
        border-radius: ${gutterSizes.base} ${gutterSizes.base} 0 0;
        width: 100%;
        max-height: 90%;
    }

    .hint-tooltip-direction--top.hint-tooltip-content--right {
        top: auto;
        margin-top: -184px;
        transform: translateX(0);
        &:before {
            display: none;
        }
    }

    ${mediaQuery.from(breakpoints.medium)} {
        fieldset[name='provide-phone'] {
            margin-top: ${gutterSizes.base};
        }

        .hint-tooltip-direction--top.hint-tooltip-content--right {
            left: -100%;
        }
    }
`;

export const MessageEncourageDialogContent = styled.div``;

export const Title = styled.h2`
    font-size: ${fontSizes.xlarge};
    padding: 0;
    margin: 0;
`;

export const SendMessageDescription = styled.p`
    font-size: ${fontSizes.small};
    color: ${colors.darkGrey};
    line-height: ${lineHeights.small};
    margin: ${gutterSizes.base} 0;
`;

export const TipDescription = styled.p`
    font-size: ${fontSizes.small};
    color: ${colors.newDarkGrey};
    line-height: ${lineHeights.small};
    padding: ${gutterSizes.large};
    border-radius: ${boxSizes.borderRadius8};
    background-color: ${colors.bgInfo};
    margin: ${gutterSizes.base} 0 ${gutterSizes.large};

    ${mediaQuery.until(breakpoints.medium)} {
        margin-top: ${gutterSizes.medium};
    }
`;

export const ContactSeller = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 68px;
    border-radius: ${boxSizes.borderRadius8};
    border: 1px solid ${colors.newBorder};
    margin-top: ${gutterSizes.medium};

    .icon--color-foregroundSubdued {
        &::before {
            color: ${colors.foregroundSubdued};
        }
    }
`;

export const SellerName = styled.div`
    font-size: ${fontSizes.small};
    color: ${colors.foregroundSubdued};
    line-height: ${lineHeights.small};
`;

export const PhoneNumberWrapper = styled.div`
    display: flex;
    align-items: center;
    margin-top: 6px;
    gap: ${gutterSizes.small};
`;

export const PhoneNumber = styled.span`
    color: ${colors.foregroundSubdued};
    font-size: ${fontSizes.header};
    line-height: ${lineHeights.medium};
    font-weight: ${fontWeights.bold};
`;
